import React, { useState } from 'react';
import css from './SectionAmenities.module.css';

const INITIAL_COUNT = 6;

const FEATURE_FIELD_KEYS = ['boat_features', 'included_accessories'];
const FEATURE_FIELD_HEADINGS = new Set(['Boat Features', 'Included Accessories']);
const SAFETY_FIELD_KEYS = ['safety_equipment'];
const SAFETY_FIELD_HEADINGS = new Set(['Safety Equipment']);

const ItemGrid = ({ items, initialCount = 6, expandLabel }) => {
  const [showAll, setShowAll] = useState(false);
  if (items.length === 0) return null;
  const visible = showAll ? items : items.slice(0, initialCount);
  const hasMore = items.length > initialCount;
  return (
    <>
      <div className={`${css.grid}${!showAll ? ` ${css.gridCollapsed}` : ''}`}>
        {visible.map(item => (
          <div key={item.key} className={css.item}>
            <span className={css.checkmark}>✓</span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
      {hasMore ? (
        <button type="button" className={css.showAllBtn} onClick={() => setShowAll(s => !s)}>
          {showAll ? 'Show less' : expandLabel}
        </button>
      ) : null}
    </>
  );
};

const SectionAmenities = ({ amenityFields }) => {
  if (!amenityFields || amenityFields.length === 0) return null;

  const getItems = (keys, headings) =>
    amenityFields
      .filter(f => keys.includes(f.key) || headings.has(f.heading))
      .flatMap(f => (f.options || []).filter(o => (f.selectedOptions || []).includes(o.key)));

  const featureItems = getItems(FEATURE_FIELD_KEYS, FEATURE_FIELD_HEADINGS);
  const safetyItems = getItems(SAFETY_FIELD_KEYS, SAFETY_FIELD_HEADINGS);

  if (featureItems.length === 0 && safetyItems.length === 0) return null;

  return (
    <section className={css.root}>
      <h2 className={css.heading}>Amenities</h2>
      <ItemGrid
        items={featureItems}
        initialCount={INITIAL_COUNT}
        expandLabel={`Show all features (${featureItems.length})`}
      />
      {safetyItems.length > 0 ? (
        <div className={css.safetySection}>
          <h3 className={css.subheading}>Safety Equipment</h3>
          <ItemGrid
            items={safetyItems}
            initialCount={INITIAL_COUNT}
            expandLabel={`Show all safety equipment (${safetyItems.length})`}
          />
        </div>
      ) : null}
    </section>
  );
};

export default SectionAmenities;
